import { fCurrency } from "../../../helper/formatNumber";
import "./CardWinnerAward.css";

const locale = require("react-redux-i18n").I18n;

const Winner1 = ({ name, value }) => {
  return (
    <div>
      <div style={{ paddingTop: "60px" }}>
        <div
          style={{
            width: "130px",
            height: "250px",
            backgroundColor: "#FEE9BD",
            borderRadius: "20px 20px 0 0",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-65px",
              left: "50%",
              transform: "translateX(-50%)",
              textAlign: "center",
            }}
          >
            <div>{name}</div>
            <div
              className="podium-span"
              style={{
                backgroundColor: "#FFF8D0",
                borderRadius: "12px",
                padding: "4px 4px",
                marginTop: "4px",
                width: "fit-content",
                paddingLeft: "16px",
                paddingRight: "16px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              {fCurrency(value)}
            </div>
          </div>
          <div
            style={{
              fontSize: "64px",
              fontWeight: "800",
              color: "#7E6D32",
              position: "absolute",
              top: "30px",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            1
          </div>
        </div>
      </div>
    </div>
  );
};

const Winner2 = ({ name, value }) => {
  return (
    <div>
      <div style={{ paddingTop: "60px" }}>
        <div
          style={{
            width: "130px",
            height: "190px",
            backgroundColor: "#ECECEC",
            borderRadius: "20px 20px 0 0",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-65px",
              left: "50%",
              transform: "translateX(-50%)",
              textAlign: "center",
            }}
          >
            <div>{name}</div>
            <div
              className="podium-span"
              style={{
                backgroundColor: "#FFF8D0",
                borderRadius: "12px",
                padding: "4px 4px",
                marginTop: "4px",
                width: "fit-content",
                paddingLeft: "16px",
                paddingRight: "16px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              {fCurrency(value)}
            </div>
          </div>
          <div
            style={{
              fontSize: "64px",
              fontWeight: "800",
              color: "#7E6D32",
              position: "absolute",
              top: "30px",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            2
          </div>
        </div>
      </div>
    </div>
  );
};

const Winner3 = ({ name, value }) => {
  return (
    <div>
      <div style={{ paddingTop: "60px" }}>
        <div
          style={{
            width: "130px",
            height: "160px",
            backgroundColor: "#DAC9C5",
            borderRadius: "20px 20px 0 0",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-65px",
              left: "50%",
              transform: "translateX(-50%)",
              textAlign: "center",
              width: '100%'
            }}
          >
            <div>{name}</div>
            <div
              className="podium-span"
              style={{
                backgroundColor: "#FFF8D0",
                borderRadius: "12px",
                padding: "4px 4px",
                marginTop: "4px",
                width: "fit-content",
                paddingLeft: "16px",
                paddingRight: "16px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              {fCurrency(value)}
            </div>
          </div>
          <div
            style={{
              fontSize: "64px",
              fontWeight: "800",
              color: "#7E6D32",
              position: "absolute",
              top: "30px",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            3
          </div>
        </div>
      </div>
    </div>
  );
};

const CardWinnerAward = ({ data }) => {
  return (
    <div
      className="border d-flex flex-column podium-container"
      style={{ borderRadius: "8px", gap: "16px", padding: "20px" }}
    >
      <div className="text-bold" style={{ fontSize: "16px" }}>
        {locale.t("contestAward.winner_award")}
      </div>
      <div
        className="podium-size"
        style={{
          display: "flex",
          gap: "14px",
          alignItems: "end",
          justifyContent: "center",
          width: "100%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        {data?.[1] && (
          <Winner2
            name={
              <span
                className="podium-span"
                style={{
                  fontSize: "14px",
                  maxWidth: "150px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "inherit"
                }}
              >
                {data?.[1]?.participant?.username || "-"}
              </span>
            }
            value={data?.[1]?.reward.value}
          />
        )}
        {data?.[0] && (
          <Winner1
            name={
              <span
                className="podium-span"
                style={{
                  fontSize: "14px",
                  maxWidth: "150px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "inherit"
                }}
              >
                {data?.[0]?.participant?.username || "-"}
              </span>
            }
            value={data?.[0]?.reward.value}
          />
        )}
        {data?.[2] && (
          <Winner3
            name={
              <span
                className="podium-span"
                style={{
                  fontSize: "14px",
                  maxWidth: "150px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "inherit"
                }}
              >
                {data?.[2]?.participant?.username || "-"}
              </span>
            }
            value={data?.[2]?.reward.value}
          />
        )}
      </div>
      {data?.length > 0 && (
        <div
          style={{
            textAlign: "center",
            color: "#A3A3A3",
            whiteSpace: "pre-line"
          }}
        >
          {locale.t("contestAward.description")}
        </div>
      )}
    </div>
  );
};

export default CardWinnerAward;
